import { v4 } from 'uuid'

import { createSelector } from '@app/utils/createSelector'

import { getCandidateSurvey } from '@app/packages/api/v2/actions/candidate_survey'
import type { ApiCandidateSurvey } from '@app/packages/api/v2/types/entities'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callV2Api } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'

import { profileUserResultSelector } from './profile'

const candidateSurveySlice = createReduxSlice<SliceState<ApiCandidateSurvey | null>>('candidate_survey')
const candidateSurveyHashSlice = createReduxSlice<string>('candidate_survey_hash')

export const candidateSurveyResultSelector = createSelector(
  [candidateSurveySlice.selector, candidateSurveyHashSlice.selector, profileUserResultSelector],
  (state, statehash, userResult) =>
    createLoadable(c => {
      const user = c.unwrap(userResult)
      if (!user) return null
      if (user.account_type !== 'sitter') return null

      return withCheckedSliceState(c, {
        sliceState: state,
        slice: candidateSurveySlice,
        hash: [user.id, statehash ?? ''].join(':'),
        load: async dispatch => {
          const resp = await dispatch(callV2Api(getCandidateSurvey()))
          return resp.data
        },
      })
    })
)

export const invalidateCandidateSurvey = () => candidateSurveyHashSlice.set(v4())
